module.exports = __webpack_public_path__ + "img/Barre_Filtre_MercuComparative.f7b70685.png";